<template>
  <div class="listbox-item">
    <div class="item-info" @click="actionEvent('item')">
      <!-- 插槽的默认内容 -->
      <slot>
        <div class="item-name">
          <span v-for="(tag, index) in itemMap.nametags || []" :key="index" class="item-nametag">
            {{ tag.text }}
          </span>
          {{ itemMap.name }}
        </div>
        <div class="item-subname">
          {{ itemMap.subname }}
        </div>
      </slot>
    </div>
    <div v-if="actionType" @click="actionEvent('action')" class="item-action">
      <img src="../../../../assets/images/icon_text.png" class="icon-text" :class="actionType" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListboxItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    listMap: {
      type: Function,
      default: () => null
    },
    action: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      actionTypes: {
        edit: {
          iconfont: 'iconedit'
        }
      }
    }
  },
  computed: {
    itemMap() {
      const { item, listMap } = this
      return listMap ? listMap(item) : item
    },
    actionType() {
      const { action: a, actionTypes: t } = this
      return a && (a.iconfont || t[a.name].iconfont)
    }
  },
  methods: {
    actionEvent(type) {
      this.$emit('item-action', { type })
    }
  }
}
</script>

<style lang="scss" scoped>
.listbox-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.48rem;
  border-bottom: 1px solid #eeeeee;
  background-color: #fff;
  // 信息
  .item-info {
    padding-right: 0.48rem;
    flex: 1;
    text-align: left;
    font-size: 0.36rem;
    // 名字
    .item-name {
      display: flex;
      align-items: center;
      padding-bottom: 0.16rem;
      font-weight: bold;
      .item-nametag {
        display: inline-block;
        background: #d7e7e7;
        color: #00b25a;
        font-size: 0.2rem;
        padding: 0.04rem 0.08rem;
        margin-right: 0.16rem;
        border-radius: 0.04rem;
        font-weight: normal;
      }
    }
    // 次要名字
    .item-subname {
      color: #666666;
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
  }
  .icon-text {
    width: 0.48rem;
    height: 0.48rem;
  }
  .item-action {
    display: inherit;
    .iconfont {
      font-size: 20px;
    }
  }
  .icon-address {
    display: block;
    font-size: 36px;
  }
}
</style>
